module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error":"Error to load captcha.","captcha":"Captcha Verification"},"zh":{"error":"加载验证码出错。","captcha":"验证码验证"},"kr":{"error":"보안 문자를 로드하는 동안 오류가 발생했습니다.","captcha":"보안 문자 확인"}}')
  delete Component.options._Ctor
}
